import React from 'react'
import { NavLink } from 'react-router-dom';
import intro from './assets/intro.jpg'
import Button from '@material-ui/core/Button';
import BCC from './assets/BCC.jpg'
import flow from './assets/flowchart.jpg'
import pseudo from './assets/Pseudo.png'
import flowQ from './assets/flowQ.png'
import temp from './assets/template.png'
import funct from './assets/function.gif'
import Data from './assets/Data.png'
import scope from './assets/scope.jpg'
import BTS from './assets/BTS.png'
import keyword from './assets/Keywords.jpeg'
import loop from './assets/loop.png'
import tern from './assets/ternary.png'
import loopQ from './assets/loopQ.jpg'
import main from './assets/main.png'
import odd from './assets/odd.png'
import prime from './assets/prime.png'
import pyramid from './assets/pyramid.png'
import alpha from './assets/alpha.jpg'
import diam from './assets/diam.png'
import coc from './assets/coc.jpg'
import num from './assets/num.jfif'
import sqrt from './assets/sqrt.png'
import mean from './assets/mean.jpg'
import DB from './assets/DB.png'
import Arr from './assets/Array.png'
import ArrN from './assets/ArrN.png'
import algo from './assets/algo.jfif'
import ls from './assets/ls.jpg'
import bs from './assets/bs.png'
import ss from './assets/ss.png'
import is from './assets/is.png'
import swap from './assets/swap.png'
import comb from'./assets/comb.png'
import mrge from './assets/mrge.jfif'
import ptr from './assets/ptr.jfif'
import bble from './assets/bble.png'
import D from './assets/2D.png'
import Rtt from './assets/Rtt.png'
import str from './assets/str.jfif'
import strRev from './assets/strRev.jpg'
import RevArr from './assets/RevArr.gif'
import count from './assets/count.jfif'
import sub from './assets/sub.png'
import ltw from './assets/ltw.jpg'
import splt from './assets/splt.jfif'
import rec from './assets/rec.png'
import fact from './assets/fact.png'
import sn from './assets/sn.png'
import DMA from './assets/DMA.jfif'
import nque from './assets/nque.png'
import dic from './assets/dic.jfif'
import rmz from './assets/rmz.jfif'
import stk from './assets/stk.png'
import q from './assets/q.jfif'
import ll from './assets/ll.jfif'
import lex from './assets/lex.png'
const CB = () => {

    return (
        <div>
          <h1 style={{textAlign:'center'}}>Topics to be covered</h1>
        <div class="cards-list" data-aos="fade-left" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image">
      <img src={intro} alt="intro" />  </div>
    <div class="card_title title-white">
     <p style={{color:'whitesmoke'}}>Intro</p>
      <NavLink to='/category/c/introduction'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      <img src={BCC} alt="" />
     
      </div>
    <div class="card_title title-white">
      <p>Basic Computer Components</p>
      <NavLink to='/category/c/Basic-Computer-Components'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
     <img src={flow} alt="" />
    </div>
    <div class="card_title">
        <p style={{color:'whitesmoke'}}>Flowchart</p>
        <NavLink to='/category/c/Flow-Chart'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={pseudo} alt="" />
      </div>
    <div class="card_title title-black">
      <p>Pseudocode</p>
      <NavLink to='/category/c/Pseudo-Codes'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={flowQ} alt="" />
     </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.5em'}}>Print a number 10 time using flow chart and Pseudocode</p>
      <NavLink to='/category/c/tentime'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={temp} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Template</p>
      <NavLink to='/category/c/Template'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={funct} alt="" />  
    </div>
    <div class="card_title">
        <p>Function</p>
        <NavLink to="/category/c/Function">
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={Data} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Data types</p>
      <NavLink to='/category/c/data-types'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={scope} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Scope of Variable</p>
      <NavLink to='/category/c/scopes-of-variable'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={BTS} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p style={{color:'greenyellow'}}>Behind the scenes</p>
      <NavLink to='/category/c/Behind-the-Scenes'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={keyword} alt="" />  
    </div>
    <div class="card_title">
        <p>Keywords</p>
        <NavLink to='/category/c/Keywords'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={loop} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Loop</p>
      <NavLink to='/category/c/loops'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={tern} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Ternary operator</p>
      <NavLink to='/category/c/ternary-operator'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={loopQ} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.6em'}}>Print a NooB-Geeks 10 times</p>
      <NavLink to='/category/c/Print-a-NooB-Geeks-10-times'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={main} alt="" />  
    </div>
    <div class="card_title">
        <p style={{fontSize:'0.5em'}}>Can main function of any other data types?</p>
        <NavLink to='/category/c/Can-main-function-of-any-other-data-types'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={odd} alt="" />  
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'0.8em'}}>Print sum of odd till N</p>
      <NavLink to='/category/c/Print-sum-of-odd-number-till-N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={prime} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Check Prime or not?</p>
      <NavLink to='/category/c/Check-Prime-or-Not'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={pyramid} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.9em'}}>Print number Pyramid Pattern</p>
      <NavLink to='/category/c/Print-number-Pyramind-Pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={alpha} alt="" />  
    </div>
    <div class="card_title">
        <p>Print alphabet pyramid pattern</p>
        <NavLink to='/category/c/Print alphabet pyramid pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={diam} alt="" />  
      </div>
    <div class="card_title title-black">
      <p style={{color:'whitesmoke', size:'0.9em'}}>Print diamond Pyramind Pattern</p>
      <NavLink to='/category/c/Print diamond Pyramind Pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={coc} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Concepts of coding</p>
      <NavLink to='/category/c/concepts of coding'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={num} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Print largest of N</p>
      <NavLink to='/category/c/Print largest of N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={sqrt} alt="" />  
    </div>
    <div class="card_title">
        <p>Square root of Given N</p>
        <NavLink to='/category/c/Print sq rt of N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={mean} alt="" />  
      </div>
    <div class="card_title title-black">
      <p style={{color:'whitesmoke'}}>Find Mean</p>
      <NavLink to='/category/c/Find Mean'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={DB} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Decimal to Binary</p>
      <NavLink to='/category/c/Decimal-binary'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={Arr} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Array</p>
      <NavLink to='/category/c/array'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={ArrN} alt="" />  
    </div>
    <div class="card_title">
        <p>Print n number using array</p>
        <NavLink to='/category/c/Print n number using array'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={algo} alt="" />  
      </div>
    <div class="card_title title-black">
      <p style={{color:'whitesmoke'}}>Algorithm</p>
      <NavLink to='/category/c/algorithm'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={ls} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Linear Search</p>
      <NavLink to='/category/c/Linear search'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={bs} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Binary Search</p>
      <NavLink to='/category/c/binary-search'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={ss} alt="" />  
    </div>
    <div class="card_title">
        <p>Selection sort</p>
        <NavLink to='/category/c/Selection Sort'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={is} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Insertion sort</p>
      <NavLink to='/category/c/Insertion Sort'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={swap} alt="" />
     </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.9em'}}>Swapping Variabale using 2 and 3 variable</p>
      <NavLink to='/category/c/Swapping-variables'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={comb} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Print nCr number</p>
      <NavLink to='/category/c/print ncr number'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={mrge} alt="" />  
    </div>
    <div class="card_title">
        <p style={{color:'whitesmoke'}}>Merge the Elements of 2 Sorted Array</p>
        <NavLink to='/category/c/Program to Merge the Elements of 2 Sorted Array"'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={ptr} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Pointer</p>
      <NavLink to='/category/c/Pointer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={bble} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Bubble sort using pointer</p>
      <NavLink to='/category/c/Bubble sort using pointer'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={D} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>2-D array</p>
      <NavLink to='/category/c/Two Dimensional Array"'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={Rtt} alt="" />  
    </div>
    <div class="card_title">
        <p style={{fontSize:'0.7em'}}>Rotate a matrix by 90 degree anticlockwise</p>
        <NavLink to='/category/c/Rotate an array by 90 degree'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={str} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>String</p>
      <NavLink to='/category/c/String'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={strRev} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Reverse String</p>
      <NavLink to='/category/c/String Reverse'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
   
  
  
  <div class="card 3">
    <div class="card_image">
    <img src={count} alt="" />  
    </div>
    <div class="card_title">
        <p style={{fontSize:'0.5em'}}>Write a program in C to count total number of alphabets, digits and special characters in a string.</p>
        <NavLink to='/category/c/ Count_multicharacters'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={sub} alt="" />  
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'0.5em'}}> Write a program in C to extract a substring from a given string.</p>
      <NavLink to='/category/c/ substring from string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={ltw} alt="" />
     </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.6em'}}> Write a program in C to convert a string to uppercase</p>
      <NavLink to='/category/c/ toggle string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={splt} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.7em'}}>Write a program in C to split string by space into words.</p>
      <NavLink to='/category/c/ split string by space into words'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={rec} alt="" />  
    </div>
    <div class="card_title">
        <p> Recursion</p>
        <NavLink to='/category/c/recursion'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={fact} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Factorial using Recurssion</p>
      <NavLink to='/category/c/factorial'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={sn} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Sum of N Number Using Recurssion</p>
      <NavLink to='/category/c/Sum of Natural Numbers using Recursion'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={RevArr} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Array reverse Using Recurssion</p>
      <NavLink to='/category/c/ Array reverse Using Recurssion'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={bs} alt="" />  
    </div>
    <div class="card_title">
        <p>Binary Search Using Recurssion</p>
        <NavLink to='/category/c/Binary search using recursion'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={DMA} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>DMA-Dynamic Memory Allocation</p>
      <NavLink to='/category/c/DMA'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={nque} alt="" />
     </div>
    <div class="card_title title-white">
      <p>N-Queen Problem</p>
      <NavLink to='/category/c/n-queen -problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={lex} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'0.7em'}}>Recursion Permutation Lexicogrpahical Order</p>
      <NavLink to='/category/c/Recursion Permutation Lexicogrpahical Order'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={dic} alt="" />  
    </div>
    <div class="card_title">
        <p>Dictionary Order Larger</p>
        <NavLink to='/category/c/dictionary_order'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
    <img src={rmz} alt="" />  
      </div>
    <div class="card_title title-black">
      <p>Rat in a maze</p>
      <NavLink to='/category/c/Rat in a maze'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> 
    <img src={stk} alt="" />
     </div>
    <div class="card_title title-white">
      <p>Stack</p>
      <NavLink to='/category/c/stack'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
    <img src={q} alt="" /> 
      </div>
    <div class="card_title title-white">
      <p>Queue</p>
      <NavLink to='/category/c/queue'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
    <img src={ll} alt="" />  
    </div>
    <div class="card_title">
        <p>Linked List</p>
        <NavLink to='/category/c/linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   </div>

      </div>
    )
    }

export default CB
